export default __webpack_public_path__ + "static/media/lion coin.03764616.svg";